import type { ComponentConfigV2, ToonOptions } from '@/types/configurationV2'

export default function ToonOptionsEditor({
  component,
  onUpdate,
}: { component: ComponentConfigV2; onUpdate: (u: ComponentConfigV2) => void }) {
  const options = component.options as ToonOptions
  return (
    <div>
      <div className="text-xs text-gray-500 mb-1">Toon 타입</div>
      {(['intro', 'outro'] as const).map((t) => (
        <label key={t} className="flex items-center gap-1.5 text-xs">
          <input
            type="radio"
            name={`toon-${component.id}`}
            checked={options.toonType === t}
            onChange={() => onUpdate({ ...component, options: { ...options, toonType: t } })}
          />
          {{ intro: 'Intro (qn_intro)', outro: 'Outro (qn_outro)' }[t]}
        </label>
      ))}
    </div>
  )
}
